import React, { useState } from 'react';
import Tenants from './Tenants';
import Partners from './Partners';
import AdminSettings from './AdminSettings';

const Symbol = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 80 80" fill="none" aria-hidden="true">
    <polyline points="16,64 16,20 40,46 64,20 64,64" stroke="#1f9d55" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" fill="none" strokeDasharray="0.1 11" opacity="0.55" />
    <circle cx="16" cy="64" r="5" fill="#1f9d55" opacity="0.55" />
    <circle cx="40" cy="46" r="4" fill="#1f9d55" opacity="0.55" />
    <circle cx="64" cy="64" r="4" fill="#1f9d55" opacity="0.55" />
    <path d="M55.9,20.5 L64,35.35 L72.1,20.5 Z" fill="#1f9d55" />
    <circle cx="64" cy="16" r="9" fill="#1f9d55" />
    <circle cx="64" cy="16" r="3.6" fill="#ffffff" />
  </svg>
);

// Dedicated console for the master admin (ltl@mowstop.com). No landscaping
// sidebar — just a top nav: Tenants · Partners · Settings.
export default function AdminConsole({ onSignOut }) {
  const [view, setView] = useState('tenants');

  const TABS = [
    { key: 'tenants', label: 'Tenants' },
    { key: 'partners', label: 'Partners' },
    { key: 'settings', label: 'Settings' }
  ];

  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <div style={styles.brand}>
          <Symbol size={26} />
          <span style={styles.wordmark}>
            <span style={{ color: '#14653a' }}>Mow</span><span style={{ color: '#1f9d55' }}>Stop</span>
          </span>
          <span style={styles.adminTag}>Admin</span>
        </div>

        <nav style={styles.nav}>
          {TABS.map((t) => (
            <button
              key={t.key}
              style={{ ...styles.navBtn, ...(view === t.key ? styles.navBtnActive : {}) }}
              onClick={() => setView(t.key)}
            >
              {t.label}
            </button>
          ))}
        </nav>

        <button style={styles.signOut} onClick={onSignOut}>Sign out</button>
      </header>

      <main style={styles.main}>
        <div style={styles.content}>
          {view === 'tenants' && <Tenants />}
          {view === 'partners' && <Partners />}
          {view === 'settings' && <AdminSettings />}
        </div>
      </main>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f7f9f4', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' },
  header: {
    background: '#fff',
    borderBottom: '1px solid #e3e9df',
    height: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    position: 'sticky',
    top: 0,
    zIndex: 50,
    gap: 16,
    flexWrap: 'wrap'
  },
  brand: { display: 'flex', alignItems: 'center', gap: 9 },
  wordmark: { fontFamily: 'Manrope, sans-serif', fontWeight: 800, fontSize: 20, letterSpacing: '-0.4px', lineHeight: 1 },
  adminTag: { fontSize: 10.5, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#14653a', background: '#ecf8ee', border: '1px solid #cfe9d4', borderRadius: 100, padding: '3px 9px', marginLeft: 4 },
  nav: { display: 'flex', gap: 4, background: '#f3f4ef', borderRadius: 10, padding: 4 },
  navBtn: { padding: '8px 18px', borderRadius: 7, border: 'none', background: 'transparent', fontSize: 13.5, fontWeight: 700, color: '#5f6b58', cursor: 'pointer', fontFamily: 'inherit' },
  navBtnActive: { background: '#fff', color: '#14653a', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' },
  signOut: { padding: '7px 14px', border: '1px solid #e3e9df', background: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 600, color: '#5f6b58', cursor: 'pointer', fontFamily: 'inherit' },
  main: { display: 'flex', justifyContent: 'center' },
  content: { width: '100%', maxWidth: 1080, padding: '28px 24px' }
};
